"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
function Error(_a) {
    var error = _a.error;
    return react_1.default.createElement("div", { className: 'col-span-2 text-center' },
        react_1.default.createElement(storybook_1.Forms.Error, null,
            react_1.default.createElement(storybook_1.Texts.Primary, { className: 'text-primary' }, error.message),
            error.button && react_1.default.createElement("div", { className: 'text-center' },
                react_1.default.createElement(storybook_1.Buttons.Link, { type: 'primary', to: error.button.to }, error.button.label))));
}
exports.default = Error;
